import React from "react";
import { useTranslation } from 'react-i18next';
import SuprimentoForm from "../../Forms/SuprimentoForm";
import { FiPlus } from "react-icons/fi";

import "./modern-styles.css";

const SuprimentoModal = ({ onClose }) => {
  const { t } = useTranslation('cashRegister');

  return (
    <div className="suprimento-modal-container">
      <div className="suprimento-header-unique">
        <h1 className="suprimento-title-unique">
          <FiPlus />
          {t('suprimento.modalTitle')}
        </h1>
        <p className="suprimento-subtitle-unique">
          {t('suprimento.modalSubtitle')}
        </p>
      </div>
      <div className="suprimento-form-container-unique">
        <SuprimentoForm onClose={onClose} />
      </div>
    </div>
  );
};

export default SuprimentoModal;
